

import { IconSearch } from '@tabler/icons-react'
import './styles.scss'

import { Input } from '@fragments'

export default function Search() {
    return (
        <div className="cs-sidebar-search mt-3">
            <Input
                placeholder='Buscar (em breve)'
                end={<IconSearch />}
                disabled
            />
        </div>
    )
}   